// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ffff9052","213":"11e19cfe","227":"8cc4063a","239":"7c169d40","455":"4bc7260b","488":"c1362059","586":"f067c5bd","713":"56a568b1","726":"5e075b71","879":"ea593920","948":"0ef3e695"}[chunkId] + ".chunk.js";
};